"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteQuoteRequestRelation = exports.postQuoteRequestRelation = exports.putQuoteRequestOrganization = exports.putQuoteRequestAccessibility = exports.deleteQuoteRequestPermission = exports.postQuoteRequestPermission = exports.putQuoteRequestAction = exports.postQuoteRequest = exports.putQuoteRequest = exports.getQuoteRequest = exports.getQuoteRequests = void 0;

var common_1 = require("../common");

var root_1 = require("./root");

var quoterequestsAuthorizedPath = root_1.ecommerceAuthorized + '/quoterequests/';

var getQuoteRequests = function getQuoteRequests(authentication, queryParameters) {
  return common_1.get(authentication, quoterequestsAuthorizedPath, queryParameters);
};

exports.getQuoteRequests = getQuoteRequests;

var getQuoteRequest = function getQuoteRequest(authentication, id) {
  return common_1.get(authentication, quoterequestsAuthorizedPath + id);
};

exports.getQuoteRequest = getQuoteRequest;

var putQuoteRequest = function putQuoteRequest(authentication, quoterequest) {
  return common_1.put(authentication, quoterequestsAuthorizedPath + quoterequest.id, quoterequest);
};

exports.putQuoteRequest = putQuoteRequest;

var postQuoteRequest = function postQuoteRequest(authentication, quoterequest) {
  return common_1.post(authentication, quoterequestsAuthorizedPath, quoterequest);
};

exports.postQuoteRequest = postQuoteRequest;

var putQuoteRequestAction = function putQuoteRequestAction(authentication, id, action, data) {
  return common_1.putSub(authentication, quoterequestsAuthorizedPath, id, action, data);
};

exports.putQuoteRequestAction = putQuoteRequestAction;

var postQuoteRequestPermission = function postQuoteRequestPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, quoterequestsAuthorizedPath, id, permission);
};

exports.postQuoteRequestPermission = postQuoteRequestPermission;

var deleteQuoteRequestPermission = function deleteQuoteRequestPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, quoterequestsAuthorizedPath, id, permissionId);
};

exports.deleteQuoteRequestPermission = deleteQuoteRequestPermission;

var putQuoteRequestAccessibility = function putQuoteRequestAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, quoterequestsAuthorizedPath, id, accessibility);
};

exports.putQuoteRequestAccessibility = putQuoteRequestAccessibility;

var putQuoteRequestOrganization = function putQuoteRequestOrganization(authentication, id, organizationId) {
  return common_1.putEntityOrganization(authentication, quoterequestsAuthorizedPath, id, organizationId);
};

exports.putQuoteRequestOrganization = putQuoteRequestOrganization;

var postQuoteRequestRelation = function postQuoteRequestRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, quoterequestsAuthorizedPath, id, relation);
};

exports.postQuoteRequestRelation = postQuoteRequestRelation;

var deleteQuoteRequestRelation = function deleteQuoteRequestRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, quoterequestsAuthorizedPath, id, relationId);
};

exports.deleteQuoteRequestRelation = deleteQuoteRequestRelation;